import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import AboutUs from '@/components/AboutUs.vue'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import TermsOfService from '@/components/TermsOfService.vue'
import AgreementTeacher from '@/components/teacher/AgreementTeacher.vue'
import SignupTeacher from '@/components/teacher/SignupTeacher.vue'
import SignupTeaFB from '@/components/teacher/SignupTeaFB.vue'
import DetailTeacher from '@/components/teacher/DetailTeacher.vue'
import EditTeacher from '@/components/teacher/EditTeacher.vue'
// import CourseList from '@/components/teacher/CourseList.vue'
import DetailCourse from '@/components/teacher/DetailCourse.vue'
import CreateCourse from '@/components/teacher/CreateCourse.vue'
import CreateClass from '@/components/teacher/CreateClass.vue'
import ManageClass from '@/components/teacher/ManageClass.vue'
import EditClass from '@/components/teacher/EditClass.vue'
import ClassList from '@/components/teacher/ClassList.vue'
import DetailClass from '@/components/teacher/DetailClass.vue'
import EnrollClassDetail from '@/components/teacher/DetailEnrollClass.vue'
import SchoolList from '@/components/school/SchoolList.vue'
import TeacherList from '@/components/teacher/TeacherList.vue'
import DetailListTeacher from '@/components/teacher/DetailListTeacher.vue'
import ChangePassword from '@/components/teacher/ChangePassword.vue'
import ManageStudent from '@/components/teacher/ManageStudent.vue'
import ManageCourse from '@/components/teacher/ManageCourse.vue'
import EditCourse from '@/components/teacher/EditCourse.vue'
import LookStudentProfile from '@/components/teacher/LookStudentProfile.vue'
import LookTeacherProfile from '@/components/student/LookTeacherProfile.vue'
import LookSchoolProfile from '@/components/student/LookSchoolProfile.vue'
import AgreementStudent from '@/components/student/AgreementStudent.vue'
import SignupStudent from '@/components/student/SignupStudent.vue'
import SignupStuFB from '@/components/student/SignupStuFB.vue'
import DetailStudent from '@/components/student/DetailStudent.vue'
import EditStudent from '@/components/student/EditStudent.vue'
import ChangePasswordStudent from '@/components/student/ChangePasswordStudent.vue'
import NewsList from '@/components/news/NewsList.vue'
import NewsDetail from '@/components/news/NewsDetail.vue'
import TeacherNotification from '@/components/notification/TeacherNotification.vue'
import TeacherNotificationDetail from '@/components/notification/TeacherNotificationDetail.vue'
import StudentNotification from '@/components/notification/StudentNotification.vue'
import StudentNotificationDetail from '@/components/notification/StudentNotificationDetail.vue'
import ForgetPassword from '@/components/password/ForgetPassword.vue'
import ResetPassword from '@/components/password/ResetPassword.vue'
import CourseRequest from '@/components/student/CourseRequest.vue'
import EnrollStudentList from '@/components/student/EnrollStudentClass.vue'
import CourseRequestList from '@/components/student/CourseRequestList.vue'
import CourseRequestDetail from '@/components/student/CourseRequestDetail.vue'
import Policy from '@/components/Policy.vue'
import ContentGroup from '@/components/upload/ContentGroup.vue'
import ContentUpload from '@/components/upload/ContentUpload.vue'
import ContentList from '@/components/upload/ContentList.vue'
import CreateContentGroup from '@/components/upload/CreateContentGroup.vue'
import EditContentGroup from '@/components/upload/EditContentGroup.vue'
import ContentUpdate from '@/components/upload/ContentUpdate.vue'
import PaymentUpload from '@/components/student/PaymentUpload.vue'
import CoursePayment from '@/components/student/CoursePayment.vue'
import VideoStreaming from '@/components/VideoStreaming.vue'
import ImageStreaming from '@/components/ImageStreaming.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import ClassListTab from '@/components/teacher/ClassListTab.vue'
import DetailVideoCourse from '@/components/teacher/DetailVideoCourse.vue'
import PaymentTab from '@/components/teacher/PaymentTab.vue'
import InvoiceDetail from '@/components/teacher/InvoiceDetail.vue'
import VideoInvoiceDetail from '@/components/teacher/VideoInvoiceDetail.vue'
import EnrollCourseList from '@/components/student/EnrollCourseStudentList.vue'
import ClassContentGroup from '@/components/student/ClassContentGroup.vue'
import ClassContentList from '@/components/student/ClassContentList.vue'
import CourseContentList from '@/components/student/CourseContentList.vue'
import CourseContentGroup from '@/components/student/CourseContentGroup.vue'
import PaymentMethod from '@/components/student/PaymentMethod.vue'
import TeacherPayment from '@/components/teacher/TeacherPayment.vue';
import NotFound from '@/components/NotFound'
import Forbidden from '@/components/Forbidden'
import Delete from '@/components/Delete.vue'
import AgreementSchool from '@/components/school/AgreementSchool.vue'
import SignupSchool from '@/components/school/SignUpSchool.vue'
import DetailSchool from '@/components/school/DetailSchool.vue'
import EditSchool from '@/components/school/EditSchool.vue'
import SchoolNotification from '../components/notification/SchoolNotification.vue'
import SchoolNotificationDetail from '../components/notification/SchoolNotificationDetail.vue'
import AttendanceCreate from '../components/attendance/AttendanceCreate.vue'
import ClassAttendance from '../components/attendance/classAttendance.vue'
import ClassSessionList from '../components/classSession/ClassSessionList.vue'
import ClassSessionDetail from '../components/classSession/ClassSessionDetail.vue'
import ClassSessionEdit from '../components/classSession/ClassSessionEdit.vue'
import ClassSessionCreate from '../components/classSession/ClassSessionCreate.vue'
import ManageAssignment from '@/components/assignment/ManageAssignment.vue'
import CreateAssignment from '@/components/assignment/CreateAssignment.vue'
import EditAssignment from '@/components/assignment/EditAssignment.vue'
import DetailEnrollCourse from '@/components/teacher/DetailEnrollCourse.vue'
import AssignmentList from '@/components/assignment/AssignmentList.vue'
import DetailAssignment from '@/components/assignment/DetailAssignment.vue'
import AttendanceDetail from '../components/attendance/AttendanceDetail.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: Home
},
{
    path: '/login',
    name: 'login',
    component: Login
},
{
    path: '/about-us',
    name: 'aboutUs',
    component: AboutUs
},
{
    path: '/request-account-deletion',
    name: 'delete',
    component: Delete,
    meta: {
        permission: ['teacher', 'student', 'school']
    }
},
{
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
},
{
    path: '/terms-of-service',
    name: 'termsOfService',
    component: TermsOfService
},
{
    path: '/editCourse/:id',
    name: 'editCourse',
    component: EditCourse,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/enrollClassList',
    name: 'enrollStudentList',
    component: EnrollStudentList
},
{
    path: '/enrollCourseList',
    name: 'enrollCourseList',
    component: EnrollCourseList
},
{
    path: '/manageCourse',
    name: 'manageCourse',
    component: ManageCourse,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/courseRequest',
    name: 'courseRequest',
    component: CourseRequest
},
{
    path: '/courseRequestList',
    name: 'courseRequestList',
    component: CourseRequestList
},
{
    path: '/courseRequestDetail/:id',
    name: 'courseRequestDetail',
    component: CourseRequestDetail
},
{
    path: '/logout',
    name: 'logout',
    component: Home
},
{
    path: '/lookSchoolProfile/:id',
    name: 'lookSchoolProfile',
    component: LookSchoolProfile
},
{
    path: '/lookTeacherProfile/:id',
    name: 'lookTeacherProfile',
    component: LookTeacherProfile
},
{
    path: '/lookStudentProfile/:id',
    name: 'lookStudentProfile',
    component: LookStudentProfile
},
{
    path: '/password/forget',
    name: 'forgetPassword',
    component: ForgetPassword
},
{
    path: '/password/reset',
    name: 'resetPassword',
    component: ResetPassword,
    query: {
        token: 'token'
    }
},
{
    path: '/agreementteacher',
    name: 'agreementTeacher',
    component: AgreementTeacher
},
{
    path: '/signupteacher',
    name: 'signupTeacher',
    component: SignupTeacher
},
{
    path: '/teacherPayment',
    name: 'teacherPayment',
    component: TeacherPayment
},
{
    path: '/signupTeaFB',
    name: 'SignupTeaFB',
    component: SignupTeaFB
},
{
    path: '/teacher/detail',
    name: 'detailTeacher',
    component: DetailTeacher,
    meta: {
        permission: 'teacher'
    }
},
{
    path: '/teacher/edit',
    name: 'editTeacher',
    component: EditTeacher,
    meta: {
        permission: 'teacher'
    }
},
{
    path: '/school/list/detail/:id',
    name: 'detailListSchool',
    component: DetailListTeacher,
    meta: {
        type: 'school'
    }
},
{
    path: '/teacher/list/detail/:id',
    name: 'detailListTeacher',
    component: DetailListTeacher,
    meta: {
        type: 'teacher'
    }
},
// {
//     path: '/course/list',
//     name: 'courseList',
//     component: CourseList,
// },
{
    path: '/course/detail/:id',
    name: 'detailCourse',
    component: DetailCourse,
},
{
    path: '/enroll/course/detail/:id',
    name: 'enrollCourseDetail',
    component: DetailEnrollCourse
},
{
    path: '/createcourse',
    name: 'createCourse',
    component: CreateCourse,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/createclass',
    name: 'createClass',
    component: CreateClass,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/manageclass',
    name: 'manageClass',
    component: ManageClass,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/manageclass/edit/:id',
    name: 'editClass',
    component: EditClass,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/class/list',
    name: 'classList',
    component: ClassList,
},
{
    path: '/class/detail/:id',
    name: 'detailClass',
    component: DetailClass
    // linked from backend (email link)
},
{
    path: '/enroll/class/detail/:id',
    name: 'enrollClassDetail',
    component: EnrollClassDetail
},
{
    path: '/teacher/changepassword',
    name: 'changeTeacherPassword',
    component: ChangePassword
},
{
    path: '/managestudent',
    redirect: () => {
        const userType = store.getters.userType;
        return `/${userType}/managestudent`;
    },
    name: 'manageStudent',
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/teacher/managestudent',
    name: 'manageStudentTeacher',
    component: ManageStudent,
    meta: {
        permission: 'approved_teacher'
    }
},
{
    path: '/school/managestudent',
    name: 'manageStudentSchool',
    component: ManageStudent,
    meta: {
        permission: 'approved_school'
    }
},
{
    path: '/school/list',
    name: 'schoolList',
    component: SchoolList,
},
{
    path: '/teacher/list',
    name: 'teacherList',
    component: TeacherList,
},
{
    path: '/agreementStudent',
    name: 'agreementStudent',
    component: AgreementStudent
},
{
    path: '/signupStudent',
    name: 'signupStudent',
    component: SignupStudent
},
{
    path: '/signupStuFB',
    name: 'SignupStuFB',
    component: SignupStuFB
},
{
    path: '/student/detail',
    name: 'detailStudent',
    component: DetailStudent,
    meta: {
        permission: 'student'
    }
},
{
    path: '/student/edit',
    name: 'editStudent',
    component: EditStudent,
    meta: {
        permission: 'student'
    }
},
{
    path: '/student/changepassword',
    name: 'changePasswordStudent',
    component: ChangePasswordStudent,
    meta: {
        permission: 'student'
    }
},
{
    path: '/agreementSchool',
    name: 'agreementSchool',
    component: AgreementSchool
},
{
    path: '/signupSchool',
    name: 'signupSchool',
    component: SignupSchool
},
{
    path: '/detailSchool',
    name: 'detailSchool',
    component: DetailSchool,
    meta: {
        permission: 'school'
    }
},
{
    path: '/school/changepassword',
    name: 'changeSchoolPassword',
    component: ChangePassword
},
{
    path: '/school/edit',
    name: 'editSchool',
    component: EditSchool,
    meta: {
        permission: 'school'
    }
},
{
    path: '/newslist',
    name: 'newsList',
    component: NewsList,
},
{
    path: '/news/detail/:id',
    name: 'newsDetail',
    component: NewsDetail,
},
{
    path: '/teacher/notification',
    name: 'teacherNotification',
    component: TeacherNotification,
    meta: {
        permission: 'teacher'
    }
},
{
    path: '/teacher/notification/detail/:id',
    name: 'teacherNotificationDetail',
    component: TeacherNotificationDetail,
    meta: {
        permission: 'teacher'
    }
},
{
    path: '/school/notification',
    name: 'schoolNotification',
    component: SchoolNotification,
    meta: {
        permission: 'school'
    }
},
{
    path: '/school/notification/detail/:id',
    name: 'schoolNotificationDetail',
    component: SchoolNotificationDetail,
    meta: {
        permission: 'school'
    }
},
{
    path: '/student/notification',
    name: 'studentNotification',
    component: StudentNotification,
    meta: {
        permission: 'student'
    }
},
{
    path: '/student/notification/detail/:id',
    name: 'studentNotificationDetail',
    component: StudentNotificationDetail,
    meta: {
        permission: 'student'
    }
},
{
    path: '/policy',
    name: 'policy',
    component: Policy,
},
{
    path: '/contentGroup/:id',
    name: 'contentGroup',
    component: ContentGroup,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/contentUpload/:courseId/:id',
    name: 'contentUpload',
    component: ContentUpload,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/contentList/:courseId/:id',
    name: 'contentList',
    component: ContentList,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/createContentGroup/:id',
    name: 'createContentGroup',
    component: CreateContentGroup,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/editContentGroup/:courseId/:id',
    name: 'editContentGroup',
    component: EditContentGroup,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/contentUpdate/:courseId/:contentGroupId/:contentId',
    name: 'contentUpdate',
    component: ContentUpdate,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/class/:id/payment',
    name: 'paymentUpload',
    component: PaymentUpload
},
{
    path: '/video/:course_class_id/group/:group_id/content/:id',
    name: 'videoStreaming',
    component: VideoStreaming
},
{
    path: '/image/:course_class_id/group/:group_id/content/:id',
    name: 'imageStreaming',
    component: ImageStreaming
},
{
    path: '/pdf-viewer-course/:course_id/group/:group_id/content/:id',
    name: 'pdfViewer',
    component: PdfViewer
},
{
    path: '/course/list',
    name: 'classListTab',
    component: ClassListTab,
},
{
    path: '/video-class/detail/:id',
    name: 'detailVideoCourse',
    component: DetailVideoCourse,
    // linked from backend (email link)
},
{
    path: '/course/:id/payment',
    name: 'coursePayment',
    component: CoursePayment
},
{
    path: '/payment/list',
    name: 'paymentTab',
    component: PaymentTab,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/payment/invoice/:id',
    name: 'invoiceDetail',
    component: InvoiceDetail
},
{
    path: '/course-payment/invoice/:id',
    name: 'videoInvoiceDetail',
    component: VideoInvoiceDetail
},
{
    path: '/contentGroup/:course_id/class/:id',
    name: 'classContentGroup',
    component: ClassContentGroup,
    meta: {
        permission: 'student'
    }
},
{
    path: '/courseContentGroup/:id',
    name: 'courseContentGroup',
    component: CourseContentGroup,
    meta: {
        permission: 'student'
    }
},
{
    path: '/contentList/:class_id/group/:id',
    name: 'classContentList',
    component: ClassContentList,
    meta: {
        permission: 'student'
    }
},
{
    path: '/courseContentList/:courseId/group/:id',
    name: 'courseContentList',
    component: CourseContentList,
    meta: {
        permission: 'student'
    }
},
{
    path: '/payment/method',
    name: 'paymentMethod',
    component: PaymentMethod,
    meta: {
        permission: 'student'
    }
},
{
    path: '/classAttendance',
    name: 'classAttendance',
    component: ClassAttendance,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path:'/class/:id/session',
    name:'classSession',
    component: ClassSessionList,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/createassignment',
    name: 'createAssignment',
    component: CreateAssignment,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/manageAttendance',
    name: 'attendanceCreate',
    component: AttendanceCreate,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/manageassignment',
    name: 'manageAssignment',
    component: ManageAssignment,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/attendanceDetail/:id',
    name: 'attendanceDetail',
    component: AttendanceDetail,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path:'/class/:id/session/create',
    name:'classSessionCreate',
    component: ClassSessionCreate,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/manageassignment/edit/:id',
    name: 'editAssignment',
    component: EditAssignment,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path:'/class/:class_id/session/:id',
    name:'classSessionDetail',
    component: ClassSessionDetail,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path:'/class/:class_id/session/:id/edit',
    name:'classSessionEdit',
    component: ClassSessionEdit,
    meta: {
        permission: ['approved_teacher', 'approved_school']
    }
},
{
    path: '/assignment/list',
    name: 'assignmentList',
    component: AssignmentList,
    meta: {
        permission: 'student'
    }
},
{
    path: '/assignment/detail/:id',
    name: 'detailAssignment',
    component: DetailAssignment
},
{
    path: "/forbidden",
    name: "forbidden",
    component: Forbidden
},
{
    path: "/*",
    name: "notFound",
    component: NotFound,
},
]

const router = new VueRouter({
    mode: 'history',
    routes,
});

router.beforeEach((to, from, next) => {
    const userType = store.getters.userType;
    const userStatus = store.getters.userStatus;
    const allowedUserTypes = to.meta.permission;

    if (to.path === "/teacher/detail" && to.query.token) {
        next();
    } else if (to.path === "/detailSchool" && to.query.token) {
        next();
    } else if (Array.isArray(allowedUserTypes)) {
        const hasAccess = allowedUserTypes.some((permission) => {
            switch (permission) {
                case 'teacher':
                    return userType == 'teacher';
                case 'approved_teacher':
                    return userType == 'teacher' && userStatus == 2;
                case 'student':
                    return userType == 'student';
                case 'school':
                    return userType == 'school';
                case 'approved_school':
                    return userType == 'school' && userStatus == 2;
                default:
                    return false;
            }
        });

        if (hasAccess) {
            next();
        } else {
            if (allowedUserTypes.includes('approved_teacher') || allowedUserTypes.includes('approved_school')) {
                next({ name: 'forbidden' });
            } else {
                next({ name: 'login' });
            }
        }
    } else {
        switch (allowedUserTypes) {
            case 'teacher':
                if (userType == 'teacher') {
                    next();
                } else {
                    next({ name: 'login' });
                }
                break;
            case 'approved_teacher':
                if (userType == 'teacher' && userStatus == '2') {
                    next();
                } else {
                    next({ name: 'forbidden' });
                }
                break;
            case 'student':
                if (userType == 'student') {
                    next();
                } else {
                    next({ name: 'login' });
                }
                break;
            case 'school':
                if (userType == 'school') {
                    next();
                } else {
                    next({name: 'login'});
                }
                break;
            case 'approved_school':
                if (userType == 'school' && userStatus == 2) {
                    next();
                } else {
                    next({ name: 'forbidden' });
                }
                break;
            default:
                next();
        }
    }
});

export default router;
